import React from 'react';
import CardSlider2 from './ProductCardImageSlider';
import { FeaturedJobSlider } from './FeaturedJobSlider';
import FrequentlyBoughtSlider from './FrequentlyBoughtSlider';
import FlashSaleSlider from './FlashSaleSlider';
import JustForYouSlider from './JustForYouSlider';
import ProductDetailsSliderV2 from './ProductDetailsSliderV2';
import RecentlyViewedSlider from './RecentlyViewedSlider';
import SuggestedItemsSlider from './SuggestedItemsSlider';
import WhatAreYouLookingSlider from './WhatAreYouLookingSlider';
import OtherBrandsSlider from './OtherBrandsSlider';
import CampaignHeroBannerCarousel from './CampaignHeroBannerCarousel';
import SimilarItemsSlider from './SimilarItemsSlider';
import CardSlider3 from './CardSlider3';
import OngoingCampaign from './OngoingCampaignSlider';
import TopBrandsSlider from './TopBrandsSlider';
import CardSliderForThreeCard from './CardSliderForThreeCard';

function Slider(props) {
  const { type, ...rest } = props;

  switch (type) {
    case 'product-details-v2':
      return <ProductDetailsSliderV2 {...rest} />;
    case 'frequently-bought':
      return <FrequentlyBoughtSlider {...rest} />;
    case 'recently-viewed':
      return <RecentlyViewedSlider {...rest} />;
    case 'similar-items':
      return <SimilarItemsSlider {...rest} />;
    case 'card-slider':
      return <CardSliderForThreeCard {...rest} />;
    case 'just-for-you-slider':
      return <JustForYouSlider {...rest} />;
    case 'card-slider-2':
      return <CardSlider2 {...rest} />;
    case 'card-slider-3':
      return <CardSlider3 {...rest} />;
    case 'what-are-you-looking-slider':
      return <WhatAreYouLookingSlider {...rest} />;
    case 'other-brands-slider':
      return <OtherBrandsSlider {...rest} />;
    case 'featured-job-slider':
      return <FeaturedJobSlider {...rest} />;
    case 'campaign-hero-banner-carousel':
      return <CampaignHeroBannerCarousel {...rest} />;
    case 'flash-sale-slider':
      return <FlashSaleSlider {...rest} />;
    case 'suggested-items-slider':
      return <SuggestedItemsSlider {...rest} />;
    case 'ongoing-campaign':
      return <OngoingCampaign {...rest} />;
    case 'top-brands':
      return <TopBrandsSlider {...rest} />;
    default:
      return '';
  }
}

export default Slider;
